export default "__VITE_ASSET__B5j_WplS__"